import { createFileRoute } from "@tanstack/react-router";
import { AccessCreditsPage } from "@/pages/admin-access-credits/ui/access-credits-page";

export const Route = createFileRoute(
  "/_authed/$companySlug/admin/access-credits",
)({
  component: AccessCreditsPage,
});
